import axios from "axios";
import { attachAuthInterceptor } from "./authInterceptor";

const newsClient = axios.create({
  baseURL: import.meta.env.VITE_NEWS_API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

attachAuthInterceptor(newsClient);

export default newsClient;
